<template>
  <div>

    <navbar></navbar>

    <div class="bg-header-round-small">
      <div class="container">
        <h1>Kasse</h1>
      </div>
    </div>

    <div v-if="!cart" class="flex items-center">
      <div class="flex-1 text-grey-darker text-center px-4 py-4 m-4">
        <cg-loader :show="true" ></cg-loader>
      </div>
    </div>

    <div v-if="cart" class="container relative" >
      <checkout-summary id="summaryCheckout" :class="[fixedCheckout ? 'fixed mt-1x pin-r sm:pin-x sm:mx-10 md:pin-x md:mx-10' : 'relative mx-auto lg:absolute pin-r xl:absolute lg:mt-13x md:mb-6x', 'z-10 md:max-w-full sm:max-w-full pin-t']"></checkout-summary>
      <h2 class="mt-0 pt-0 italic">Dein Einkauf bei {{ cart.shop.name }} vom {{ formatDate(cart.updated_at) }}</h2>
      <div class="flex">
        <div class="w-full md:w-4/5 lg:w-4/5 xl:w-3/5">

          <user-address :modal-name="'delivery'" :selected="finalDeliveryAddress ? finalDeliveryAddress : {}" :title="'1. Lieferadresse'"
                        v-on:selected="selectAddress" v-on:preselected="preselectAddress" ></user-address>

          <user-address :modal-name="'invoice'" :force-preselect="finalDeliveryAddress && finalDeliveryAddress.uid ? true : false" :selected="finalInvoiceAddress ? finalInvoiceAddress : {}" :title="'2. Rechnungsadresse'"
                        v-on:selected="selectInvoiceAddresss" v-on:preselected="preselectInvoiceAddress" ></user-address>

          <payment-methods :title="'3. Bezahlung'" :selected="finalPaymentMethod ? finalPaymentMethod : {}"
                           v-on:selected="selectPaymentMethod" v-on:preselected="preselectPaymentMethod"></payment-methods>

          <carriers :title="'4. Versandart'" :selected="finalCarrier ? finalCarrier : {}" v-on:selected="selectCarrier"></carriers>

          <div>
            <label class="checkbox">
              <span>Mit dem Abschließen der Bestellung stimmst Du unseren <a
                class="text-green relative z-40" href="/service/terms-and-conditions" target="_blank">AGB</a> zu.
              </span>
              <input type="checkbox" v-model="agbCheck">
              <span class="checkmark" ></span>
            </label>
            <label class="checkbox"><span>Ich bin einverstanden und verlange ausdrücklich, dass Sie vor Ende der Widerrufsfrist mit der Ausführung der beauftragten Dienstleistung beginnen. Mir ist bekannt, dass ich bei vollständiger Vertragserfüllung durch Sie mein Widerrufsrecht verliere.</span>
              <input type="checkbox" v-model="widerrufCheck" >
              <span class="checkmark"></span>
            </label>

            <button @click.prevent="submitCart()" :class="['btn', canPay ? 'green' : 'black outline', 'block', 'mt-4x', 'mb-2x']" >Zahlungspflichtig bestellen</button>

          </div>

        </div>

      </div>

    </div>
    <cgfooter></cgfooter>

  </div>
</template>

<script>
  import Navbar from '../components/Navbar.vue'
  import CgFooter from '../components/CgFooter.vue'

  import { mapGetters, mapActions } from 'vuex'
  import formatting from '@/mixins/formatting.js'
  import UserAddress from '../components/user/userAddress'
  import PaymentMethods from '../components/user/paymentMethods'
  import Carriers from '../components/shop/Carriers'
  import CheckoutSummary from '../components/user/checkoutSummary'
  import CgLoader from '../components/menus/cgLoader'

  export default {
    name: 'Checkout',
    components: {
      CgLoader,
      CheckoutSummary,
      'carriers': Carriers,
      'paymentMethods': PaymentMethods,
      'userAddress': UserAddress,
      'navbar': Navbar,
      'cgfooter': CgFooter
    },
    mixins: [formatting],
    data () {
      return {
        agbCheck: false,
        widerrufCheck: false,
        saveToast: null,
        preselectingAddress: null,
        preselectingPayment: null,
        checkoutTop: 0,
        pageScroll: 0
      }
    },
    beforeRouteUpdate (to, from, next) {
      next()
      this.init()
    },
    created () {
      this.init()
    },
    beforeDestroy () {
      document.removeEventListener('scroll', this.scrolled)
    },
    methods: {
      ...mapActions([
        'checkoutCart',
        'getCheckoutCart',
        'updateCartAddress',
        'updateCartInvoiceAddress',
        'updateCartPayment',
        'updateCarrier'
      ]),
      initScrolled () {
        document.body.scrollTop = 0
        document.addEventListener('scroll', this.scrolled)
        var self = this
        var checkoutSetTop = function () {
          var elem = document.querySelector('#summaryCheckout')
          if (elem) {
            self.checkoutTop = elem.getBoundingClientRect().top
          } else {
            setTimeout(checkoutSetTop, 500)
          }
        }
        checkoutSetTop()
      },
      scrolled () {
        this.pageScroll = document.body.scrollTop
      },
      init () {
        this.$store.commit('CHECKOUT_RESET')
        var vm = this
        this.getCheckoutCart({
          cart: this.$route.params.cart,
          cb () {
            if (!vm.canCheckout(false, vm.cart)) {
              vm.$router.push({name: 'cart'})
            }
            vm.initScrolled()
          }
        })
      },
      submitCart () {
        if (this.canPay) {
          var self = this
          var payload = {
            cart: self.cart,
            cb: function (order) {
              self.$store.commit('CHECKOUT_SET_CART_JUST_INTO_ORDER', true)
              vm.saveToast.goAway(100)
              vm.saveToast = null
              self.$router.push({name: 'orderSummary', params: {'order': order.uid}})
            },
            errorCb: function (error) {
              self.resolveOrderError(error)
              vm.saveToast.goAway(100)
              vm.saveToast = null
            }
          }
          var vm = this
          if (!vm.saveToast) {
            vm.$dialog.confirm('Möchtest Du diese Bestellung abschließen?').then(() => {
              vm.saveToast = vm.$toasted.info('Deine Bestellung wird erstellt...', {
                theme: 'primary',
                position: 'top-right',
                duration: 10000,
                icon: 'info'
              })
              vm.checkoutCart(payload)
            })
          }
        } else {
          this.$toasted.error(this.canTPayText(), {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'close'
          })
        }
      },
      canTPayText () {
        var text = 'Du musst '
        var elements = ''
        if (!this.finalDeliveryAddress.uid) {
          elements = elements + 'eine Lieferadresse wählen, '
        }
        if (!this.finalInvoiceAddress.uid) {
          elements = elements + 'eine Rechnungsadresse wählen, '
        }
        if (!this.finalPaymentMethod.uid) {
          elements = elements + 'eine Zahlungsart wählen, '
        }
        if (!this.finalCarrier.uid) {
          elements = elements + 'eine Versandart wählen,'
        }
        if (elements !== '') {
          text = text + elements + ' und nicht vergessen, den Vereinbarungen zum Widerruf und AGBs zuzustimmen'
        } else {
          text = text + 'den Vereinbarungen zum Widerruf und AGBs zustimmen'
        }
        return text
      },
      resolveOrderError (error) {
        console.log(error)
        this.$toasted.error('Deine Bestellung kann aktuell nicht bearbeitet werden, bitte versuche es später nochmal!', {
          theme: 'primary',
          position: 'top-right',
          duration: 10000,
          action: {
            text: 'X',
            class: 'toastBtn',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
          icon: 'close'
        })
      },
      selectInvoiceAddresss (address, showNotification = true) {
        var vm = this
        if (!vm.saveToast) {
          if (showNotification) {
            vm.saveToast = vm.$toasted.info('Wird gespeichert...', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              icon: 'info'
            })
          }
          this.updateCartInvoiceAddress({
            cart: this.cart.uid,
            address: address.uid,
            type: 'billing',
            cb () {
              if (showNotification) {
                vm.$toasted.success('Die Rechnungsadresse wurde gewählt.', {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'check'
                })
                vm.saveToast.goAway(100)
                vm.saveToast = null
              } else if (vm.preselectingPayment) {
                var payment = vm.preselectingPayment
                vm.preselectingAddress = null
                vm.preselectPaymentMethod(payment)
              } else if (!vm.finalDeliveryAddress || !vm.finalDeliveryAddress.uid) {
                vm.selectAddress(address, false)
              }
            },
            errorCb () {
              if (showNotification) {
                vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'close'
                })
                vm.saveToast.goAway(100)
                vm.saveToast = null
              }
            }
          })
        }
      },
      preselectAddress (address) {
        this.preselectingAddress = address
        if (!this.preselectingPayment) {
          this.selectAddress(address, false)
        }
      },
      preselectInvoiceAddress (address) {
        this.preselectingAddress = address
        if (!this.preselectingPayment) {
          this.selectInvoiceAddresss(address, false)
        }
      },
      preselectPaymentMethod (pm) {
        this.preselectingPayment = pm
        if (!this.preselectingAddress) {
          this.selectPaymentMethod(pm, false)
        }
      },
      selectAddress (address, showNotification = true) {
        var vm = this
        if (!vm.saveToast) {
          if (showNotification) {
            vm.saveToast = vm.$toasted.info('Wird gespeichert...', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              icon: 'info'
            })
          }
          this.updateCartAddress({
            cart: this.cart.uid,
            address: address.uid,
            type: 'shipping',
            cb () {
              if (showNotification) {
                vm.$toasted.success('Die Lieferadresse wurde gewählt.', {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'check'
                })
                vm.saveToast.goAway(100)
                vm.saveToast = null
              }
              if (!(vm.finalInvoiceAddress && vm.finalInvoiceAddress.uid)) {
                vm.selectInvoiceAddresss(address, false)
              }
            },
            errorCb () {
              if (showNotification) {
                vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'close'
                })
                vm.saveToast.goAway(100)
                vm.saveToast = null
              }
            }
          })
        }
      },
      selectPaymentMethod (pm, showNotification = true) {
        var vm = this
        if (!vm.saveToast) {
          if (showNotification) {
            vm.saveToast = vm.$toasted.info('Wird gespeichert...', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              icon: 'info'
            })
          }
          this.updateCartPayment({
            cart: this.cart.uid,
            paymentDetail: pm.uid,
            cb () {
              if (showNotification) {
                vm.$toasted.success('Die Zahlungsart wurde gewählt.', {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'check'
                })
                vm.saveToast.goAway(100)
                vm.saveToast = null
              } else if (vm.preselectingAddress) {
                var address = vm.preselectingAddress
                vm.preselectingPayment = null
                if (vm.finalDeliveryAddress && vm.finalDeliveryAddress.uid) {
                  vm.preselectInvoiceAddress(address)
                } else {
                  vm.preselectAddress(address)
                }
              }
            },
            errorCb () {
              if (showNotification) {
                vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'close'
                })
                vm.saveToast.goAway(100)
                vm.saveToast = null
              }
            }
          })
        }
      },
      selectCarrier (carrier) {
        var vm = this
        if (!vm.saveToast) {
          vm.saveToast = vm.$toasted.info('Wird gespeichert...', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            icon: 'info'
          })
          this.updateCarrier({
            cart: this.cart.uid,
            carrier: carrier.uid,
            cb () {
              vm.$toasted.success('Die Versandart wurde gewählt.', {
                theme: 'primary',
                position: 'top-right',
                duration: 10000,
                action: {
                  text: 'X',
                  class: 'toastBtn',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
                icon: 'check'
              })
              vm.saveToast.goAway(100)
              vm.saveToast = null
            },
            errorCb () {
              vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
                theme: 'primary',
                position: 'top-right',
                duration: 10000,
                action: {
                  text: 'X',
                  class: 'toastBtn',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
                icon: 'close'
              })
              vm.saveToast.goAway(100)
              vm.saveToast = null
            }
          })
        }
      },
      getAddressText (address) {
        return address.street + ' ' + address.number
      },
      getPaymentText (pm) {
        return pm.card_brand + ' endet auf ' + pm.card_last4
      },
      getCarrierText () {
        return this.finalCarrier.name + ': ' + this.totalCarrierPrice(this.cart, this.finalCarrier)
      },
      getTotalCost () {
        return 0
      }
    },
    computed: {
      canPay () {
        return this.finalDeliveryAddress.uid && this.finalInvoiceAddress.uid && this.finalPaymentMethod.uid && this.finalCarrier.uid && this.agbCheck && this.widerrufCheck
      },
      fixedCheckout () {
        return this.pageScroll > this.checkoutTop
      },
      ...mapGetters({
        authenticated: 'auth_is_authenticated',
        account: 'auth_get_account',
        cart: 'checkout_get_cart',
        loading: 'options_is_loading',
        finalDeliveryAddress: 'checkout_get_address',
        finalInvoiceAddress: 'checkout_get_invoice_address',
        finalPaymentMethod: 'checkout_get_paymentMethod',
        finalCarrier: 'checkout_get_carrier'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Checkout.vue